export default __webpack_public_path__ + "static/media/bg.531145de.jpg";